import { z } from 'zod'

export const UNSCOPED = 'unscoped'
export const SUBSCRIBE = 'subscribe'
export const REDIRECT_PORTAL = 'redirect_portal'

export const CREATE_USER = 'create_user'
export const SHOW_USER = 'show_user'
export const UPDATE_USER = 'update_user'
export const DELETE_USER = 'delete_user'
export const INDEX_USER = 'index_user'
export const BLOCK_USER = 'block_user'
export const UNBLOCK_USER = 'unblock_user'
export const IMPERSONATE_USER = 'impersonate_user'
export const RESEND_VERIFICATION = 'send_verification'

export const STORE_CAMPAIGN = 'store_campaign'
export const INDEX_CAMPAIGN = 'index_campaign'
export const UPDATE_CAMPAIGN = 'update_campaign'
export const SHOW_CAMPAIGN = 'show_campaign'

export const INDEX_PHONE_NUMBERS = 'index_phone_numbers'

export const INDEX_MESSAGE_TEMPLATE = 'index_message_template'
export const STORE_MESSAGE_TEMPLATE = 'store_message_template'
export const UPDATE_MESSAGE_TEMPLATE = 'update_message_template'
export const DELETE_MESSAGE_TEMPLATE = 'delete_message_template'
export const PRIVATE_MESSAGE_TEMPLATE = 'private_message_template'

export const INDEX_CANDIDATE = 'index_candidate'
export const SHOW_CANDIDATE = 'show_candidate'
export const STORE_CANDIDATE = 'store_candidate'
export const ARCHIVE_CANDIDATE = 'archive_candidate'
export const UNARCHIVE_CANDIDATE = 'unarchive_candidate'
export const REJECT_CANDIDATE = 'reject_candidate'

export const UPDATE_CANDIDATE_COLUMN = 'update_candidate_column'

export const ANALYZE_PROMPT = 'analyze_prompt'
export const ASSISTANT_MESSAGE_PROMPT = 'assistant_message_prompt'
export const USE_INTERVIEW_AGENT = 'use_interview_agent'
export const USE_CUSTOM_AGENT = 'use_custom_agent'
export const USE_SALES_AGENT = 'use_sales_agent'

export const ADMIN_DASHBOARD = 'admin_dashboard'
export const DASHBOARD = 'dashboard'

export const MANAGE_AGENCY = 'manage_agency'

export const FACEBOOK_REDIRECT = 'facebook_redirect'
export const FACEBOOK_DISCONNECT = 'facebook_disconnect'
export const FACEBOOK_ACCOUNTS = 'facebook_accounts'
export const FACEBOOK_LEADGEN_FORMS = 'facebook_leadgen_forms'
export const INDEX_WHATSAPP_BUSINESS_ACCOUNT = 'index_whatsapp_business_account'
export const SYNC_WHATSAPP_BUSINESS_ACCOUNT = 'sync_whatsapp_business_account'

export const INDEX_ACTIVITY = 'index_activity'

export const INDEX_COMPANY = 'index_company'
export const SHOW_COMPANY = 'show_company'
export const SHOW_COMPANY_USAGE = 'show_company_usage'
export const STORE_COMPANY = 'store_company'
export const UPDATE_COMPANY = 'update_company'
export const START_COMPANY_TRIAL = 'start_company_trial'

export const INDEX_COMPANY_USER = 'index_company_user'
export const INVITE_COMPANY_USER = 'invite_company_user'
export const DELETE_COMPANY_USER = 'delete_company_user'
export const UPDATE_COMPANY_USER_ROLE = 'update_company_user_role'

export const INDEX_INVITATION = 'index_invitation'
export const DELETE_INVITATION = 'delete_invitation'

export const INDEX_CLIENT = 'index_client'
export const INVITE_CLIENT = 'invite_client'
export const DELETE_CLIENT = 'delete_client'
export const ASSIGN_CLIENT_TO_CAMPAIGN = 'assign_client_to_campaign'
export const UNASSIGN_CLIENT_FROM_CAMPAIGN = 'unassign_client_from_campaign'

export const STORE_COMMENT = 'store_comment'
export const SHOW_COMMENT = 'show_comment'

export const STORE_COLUMN = 'store_column'
export const UPDATE_COLUMN = 'update_column'
export const DELETE_COLUMN = 'delete_column'
export const REORDER_COLUMN = 'reorder_column'

export const INDEX_WEBHOOK = 'index_webhook'
export const STORE_WEBHOOK = 'store_webhook'
export const DESTROY_WEBHOOK = 'destroy_webhook'

export const INDEX_APP_CONNECTION = 'index_app_connection'
export const STORE_APP_CONNECTION = 'store_app_connection'
export const DESTROY_APP_CONNECTION = 'destroy_app_connection'

export const STORE_INTEGRATION_TOKEN = 'store_integration_token'
export const INDEX_INTEGRATION_TOKEN = 'index_integration_token'
export const DESTROY_INTEGRATION_TOKEN = 'destroy_integration_token'

export const CONNECT_SITE = 'connect_site'
export const INDEX_SITE = 'index_site'
export const SHOW_SITE = 'show_site'
export const UPDATE_SITE = 'update_site'
export const DISCONNECT_SITE = 'disconnect_site'

export const permission = z.enum([
    UNSCOPED,
    SUBSCRIBE,
    REDIRECT_PORTAL,

    CREATE_USER,
    SHOW_USER,
    UPDATE_USER,
    DELETE_USER,
    INDEX_USER,
    BLOCK_USER,
    UNBLOCK_USER,
    IMPERSONATE_USER,
    RESEND_VERIFICATION,

    STORE_CAMPAIGN,
    INDEX_CAMPAIGN,
    UPDATE_CAMPAIGN,
    SHOW_CAMPAIGN,

    INDEX_PHONE_NUMBERS,

    INDEX_MESSAGE_TEMPLATE,
    STORE_MESSAGE_TEMPLATE,
    UPDATE_MESSAGE_TEMPLATE,
    DELETE_MESSAGE_TEMPLATE,
    PRIVATE_MESSAGE_TEMPLATE,

    INDEX_CANDIDATE,
    SHOW_CANDIDATE,
    STORE_CANDIDATE,
    ARCHIVE_CANDIDATE,
    UNARCHIVE_CANDIDATE,
    REJECT_CANDIDATE,

    UPDATE_CANDIDATE_COLUMN,

    ANALYZE_PROMPT,
    ASSISTANT_MESSAGE_PROMPT,
    USE_INTERVIEW_AGENT,
    USE_CUSTOM_AGENT,
    USE_SALES_AGENT,

    ADMIN_DASHBOARD,
    DASHBOARD,

    MANAGE_AGENCY,

    FACEBOOK_REDIRECT,
    FACEBOOK_DISCONNECT,
    FACEBOOK_ACCOUNTS,
    FACEBOOK_LEADGEN_FORMS,
    INDEX_WHATSAPP_BUSINESS_ACCOUNT,
    SYNC_WHATSAPP_BUSINESS_ACCOUNT,

    INDEX_ACTIVITY,

    INDEX_COMPANY,
    SHOW_COMPANY,
    SHOW_COMPANY_USAGE,
    STORE_COMPANY,
    UPDATE_COMPANY,
    START_COMPANY_TRIAL,

    INDEX_COMPANY_USER,
    INVITE_COMPANY_USER,
    DELETE_COMPANY_USER,
    UPDATE_COMPANY_USER_ROLE,

    INDEX_INVITATION,
    DELETE_INVITATION,

    INDEX_CLIENT,
    INVITE_CLIENT,
    DELETE_CLIENT,
    ASSIGN_CLIENT_TO_CAMPAIGN,
    UNASSIGN_CLIENT_FROM_CAMPAIGN,

    STORE_COMMENT,
    SHOW_COMMENT,

    STORE_COLUMN,
    UPDATE_COLUMN,
    DELETE_COLUMN,
    REORDER_COLUMN,

    INDEX_WEBHOOK,
    STORE_WEBHOOK,
    DESTROY_WEBHOOK,

    INDEX_APP_CONNECTION,
    STORE_APP_CONNECTION,
    DESTROY_APP_CONNECTION,
    STORE_INTEGRATION_TOKEN,
    INDEX_INTEGRATION_TOKEN,
    DESTROY_INTEGRATION_TOKEN,

    CONNECT_SITE,
    INDEX_SITE,
    SHOW_SITE,
    UPDATE_SITE,
    DISCONNECT_SITE,
])

export const permissions = Object.values(permission.enum)

export type Permission = z.infer<typeof permission>
